import { ContentWrapper } from "../../components/Wrappers/Wrappers"
import { fetchAcbList, AcbListResponse, AcbListResults, AcbListParams, defaultParams } from "../../components/Rest/FetchACBList"
import { useState } from "react"
import { useEffect } from "react"
import { AcbTable } from "../../components/Accumulator/AcbTable"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { SearchField } from "../../components/SearchFields/SearchFields"
import { TableFilter } from "../../components/Pickers/tableFilters" 
import { Title } from "../../components/units/Text"


type FiltersState = {
    isExploationOpen: boolean;
}


export const ACBList = () => {
    const [acbList, setAcbList] = useState<AcbListResponse | undefined>(undefined)
    const [params, setTableParams] = useState<AcbListParams>(defaultParams())
    const [filterState, setFilterState] = useState<FiltersState>({isExploationOpen:false})
    const [loading, setLoading] = useState<boolean>(false)

    const toggleExploatationFilter = (toggle: boolean) => {
        setFilterState((prev) => ({
            ...prev, isExploationOpen : toggle
        }))
    }

    const setPage = (value: number) => {
        setTableParams((prev) => ({
            ...prev, currentPage: value
        }))
    }

    const setSearch = (search:string):void => {
        setTableParams((prev) => ({
            ...prev, search : search
        }))
    };

    const setExploatationFilter = (value: boolean | undefined):void => {
        setTableParams((prev) => ({
            ...prev, is_manufacture_date : value
        }))
    }

    const setOrder = (value: string): void => {
        setTableParams((prev) => ({
            ...prev, ordering : value
        }))
    }

    const fetchAcbs = async () => {
        if (acbList?.results) {
            setLoading(true)
        }
        fetchAcbList(params, setAcbList, setLoading)
    }

    useEffect(() => {
        fetchAcbs()
    }, [params.currentPage, params.ordering, params.is_manufacture_date])

    useEffect(() => {
        const dropTimeout = ():void => {
            clearTimeout(params.timeout)
            setTableParams((prev) => ({
                ...prev, timeout : undefined
            }))

        }
        if (params.search === undefined) {
            return
        }
        if (params.timeout) {
            dropTimeout()
        } 
        const timeout = setTimeout(() => {
            fetchAcbs()
            dropTimeout()
        }, 750) 
        setTableParams((prev) => ({
            ...prev, timeout : timeout
        }))
    }, [params.search])


    return (
        <ContentWrapper>
            <Title>Список батарей</Title>
            <br />
            <BoxWrapper p="p0">
                <FlexWrapper justifyContent="space-between" alignItems="center">
                    <BoxWrapper p="p0" style={{width: '300px'}}>
                        <TableFilter 
                            label={"Введен в эксплуатацию: "}
                            options={[{label:'Да', value: true}, {label:'Нет', value:false}]} 
                            selected={params.is_manufacture_date}  
                            isOpen={filterState.isExploationOpen}
                            setOpen={toggleExploatationFilter}
                            dataSetter={setExploatationFilter}
                            />
                    </BoxWrapper>
                    <SearchField timeout={params.timeout} setSearch={setSearch}/>
                </FlexWrapper>
            </BoxWrapper>
            <br />
            <AcbTable 
                loading={loading}
                data={acbList} 
                currentPage={params.currentPage} 
                itemsPerPage={params.limit}
                params={params}
                setter={setPage}
                orderSetter={setOrder}
                />
        </ContentWrapper>
    )
}